/**
 * @ngdoc controller
 * @name CampaignController
 * @description
 * This component renders the Campaign section.
 *
 * @memberof campaign
 */
class CampaignController {
  /**
   * Class constructor
   * @param {Service} $location        Used to redirect user after the upload process finished.
   * @param {Object}  $rootScope       To broadcast the tracking events.
   * @param {Service} appConstant      To get the profile loadingTemplates size.
   * @param {Service} campaignsService To get a campaign by Id.
   * @param {Service} errorHandler     To show any errors.
   * @param {Service} uploadQueue      We're going to need this to allow upload on this section.
   * @param {Object}  TRACKING_EVENTS  To get the name of the events to be broadcasted.
   * @ignore
   */
  constructor(
    $location,
    $rootScope,
    appConstant,
    campaignsService,
    errorHandler,
    uploadQueue,
    TRACKING_EVENTS,
  ) {
    'ngInject';

    /**
     * Local reference for the Location Service.
     * @type {Service}
     */
    this.$location = $location;
    /**
     * The local reference to the `$rootScope` object.
     * @type {Object}
     */
    this.$rootScope = $rootScope;
    /**
     * The local reference to the `campaignsService` service.
     * @type {Object}
     */
    this.campaignsService = campaignsService;
    /**
     * The local reference to the `errorHandler` service.
     * @type {Object}
     */
    this.errorHandler = errorHandler;
    /**
     * Local reference for the upload Queue Service.
     * @type {Service}
     */
    this.uploadQueue = uploadQueue;
    /**
     * The local reference to the `TRACKING_EVENTS` constant.
     * @type {Object}
     */
    this.TRACKING_EVENTS = TRACKING_EVENTS;
    /**
     * The local reference to the `campaign` object.
     * @type {Null|Object}
     */
    this.campaign = null;
    /**
     * The local reference to the `media` array.
     * @type {Array}
     */
    this.media = [];
    /**
     * The flag to display the guidelines or not.
     * @type {Boolean}
     */
    this.showGuidelines = false;
    /**
     * List of place holder; we need a list to iterate on the template.
     * @type {Array}
     */
    this.loadingItems = new Array(appConstant.pagination.campaign.loadingTemplates);
  }
  /**
   * Handle the load of the media.
   * @param {Boolean} first flag to get the Media
   *                  for the first time or load more.
   */
  _loadMedia(first) {
    this.campaign.load(first).then((media) => {
      this.media = media;
    })
    .catch((err) => this.errorHandler.handleError(err));
  }
  /**
   * Initialize variables.
   */
  $onInit() {
    this.campaignsService.getCampaignById(this.campaignId)
    .then((campaign) => {
      this.campaign = campaign;
      this._loadMedia(true);
    })
    .catch((err) => this.errorHandler.handleError(err));
  }
  /**
   * Handle the infinite scroll load more.
   */
  loadMoreMedia() {
    this._loadMedia(false);
  }
  /**
   * Change the visibility of the Guidelines.
   */
  toggleVisibleGuidelines() {
    this.showGuidelines = !this.showGuidelines;
    this.trackClick('Guidelines');
  }
  /**
   * Add the FILE oject to the upload queue service.
   * @param {FileList} selectedFiles list of seleted files by the user.
   */
  fileSelected(selectedFiles) {
    this.uploadQueue.addItems(selectedFiles, this.campaign);
    this.$location.url(`/upload/${this.campaign.id}`);
  }
  /**
   * Track the click event.
   * @param {String} type the type of click event to track.
   */
  trackClick(type) {
    this.$rootScope.$broadcast(this.TRACKING_EVENTS.campaign[`click${type}`]);
  }
}

export default CampaignController;



// WEBPACK FOOTER //
// ./src/frontend/modules/campaign/components/campaign/campaign.controller.js